import { mdiClipboardListOutline } from "@mdi/js"
import type { AdministrationSubviewConfig } from "@kontextwerk/control-web-frame/components/administration"
import type { OrgaViewFrameContext } from "../../../../context"
import { canViewOrganizationSettings } from "../../../../_shared/_logic/access"

export const subviewConfig: AdministrationSubviewConfig<OrgaViewFrameContext> = {
  id: "order-types",
  title: "Auftragstypen",
  tooltip:
    "Auftragsarten mit interner und öffentlicher Bezeichnung, Beschreibung und üblicher Dauer anlegen und bearbeiten.",
  icon: mdiClipboardListOutline,
  routeSegment: "order-types",
  getPages: (context) =>
    canViewOrganizationSettings(context)
      ? [
          {
            id: "order-types",
            title: "Auftragstypen",
            path: "",
            testId: "controlAdmin.organizationView.tab.orderTypes",
          },
        ]
      : [],
}
